import type { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

export type RatingFilterValue = null | 1 | 2 | 3 | 4 | 5

export enum ReviewSortKey {
    CreateTime = "createTime",
    Reviewer = "reviewer",
    RatingValue = "ratingValue",
}

export enum ReviewSortOrder {
    Ascend = "ascend",
    Descend = "descend",
}

// Google Review types
export type GoogleReview = {
    reviewId: string
    reviewer: {
        displayName: string
        profilePhotoUrl?: Maybe<string>
    }
    ratingValue: number
    comment?: Maybe<string>
    createTime: string
    updateTime: Maybe<string>
    reviewReply?: Maybe<{
        comment: string
        updateTime: Maybe<string>
    }>
}

export type ListReviewsResponse = {
    reviews: GoogleReview[]
    totalReviewCount: number
}

// Reply suggestions (AI generated)

export type GoogleReviewReplyInput = {
    reviewId: string
    ratingValue: number
    comment?: Maybe<string>
    reviewerDisplayName?: Maybe<string>
    // The published reply, when regenerating over one — the model is rewriting it, not writing fresh.
    existingReply?: Maybe<string>
    previousSuggestion?: Maybe<string>
    businessName?: Maybe<string>
}

// Drives which model the API picks, and how carefully a reply should be read before sending.
export enum GoogleReviewReplySeverity {
    Low = "low",
    Medium = "medium",
    High = "high",
}

export type GoogleReviewReplySuggestionResult = {
    reviewId: string
    model?: string
    severity?: GoogleReviewReplySeverity
    // The API returns exactly one suggestion today; the array is its forward-compatible shape.
    suggestions: string[]
    error?: string
}

export type GoogleReviewReplySuggestionsResponse = {
    results: GoogleReviewReplySuggestionResult[]
}
